
import React, { useState } from "react";
import { UpdatePasswordForm } from "./UpdatePasswordForm";
import { updatePassword } from "@/utils/auth";
import { useToast } from "@/hooks/use-toast";
import { useNavigate } from "react-router-dom";

interface PasswordUpdateManagerProps {
  password: string;
  setPassword: (password: string) => void;
  userEmail: string | null;
}

export const PasswordUpdateManager = ({ 
  password, 
  setPassword, 
  userEmail 
}: PasswordUpdateManagerProps) => {
  const [updatingPassword, setUpdatingPassword] = useState(false);
  const { toast } = useToast();
  const navigate = useNavigate();

  const handleUpdatePassword = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (password.length < 6) {
      toast({
        variant: "destructive",
        title: "Error",
        description: "Password must be at least 6 characters long.",
      });
      return;
    }

    setUpdatingPassword(true);

    try {
      const { error } = await updatePassword(password);
      
      if (error) throw error;
      
      toast({
        title: "Password Updated",
        description: "Your password has been updated successfully. You can now sign in with your new password.",
      });
      
      // Redirect to home page since the user is already authenticated
      navigate('/');
      
    } catch (error: any) {
      console.error("Password update error:", error);
      
      toast({
        variant: "destructive",
        title: "Error",
        description: "An error occurred while updating your password. Please try again or request a new password reset link.",
      });
    } finally {
      setUpdatingPassword(false);
    }
  };

  return (
    <UpdatePasswordForm 
      password={password}
      setPassword={setPassword}
      onSubmit={handleUpdatePassword}
      isLoading={updatingPassword}
    />
  );
};
